import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';

import Checkbox from '@material-ui/core/Checkbox';
import { FormControlLabel, FormGroup } from '@material-ui/core';

export interface IOnChangeableCheckbox {
    onChange: (checked: boolean) => void;
}

interface CheckboxWithLabelWrapperProps extends FieldRenderProps<any, any>{
    onChangeable?: IOnChangeableCheckbox;
}

export const CheckboxWithLabelWrapper: React.FunctionComponent<CheckboxWithLabelWrapperProps> = ({
    input: { checked, name, onChange: onInputChange, value, ...restInput },
    meta,
    onChangeable,
    onChange,
    label,
    ...rest
}) => {

    const onChangeCombined = React.useCallback((event: React.ChangeEvent<HTMLInputElement>, checkedValue: boolean) => {
        if (onChange) {
            onChange(event, checkedValue);
        }

        onInputChange(checkedValue);
    }, [onChange, onInputChange]);

    return (
        <FormGroup row>
            <FormControlLabel
                control={
                    <Checkbox
                        {...rest}
                        name={name}
                        inputProps={restInput}
                        onChange={onChangeCombined}
                        checked={value ? true : false}
                    />
                }
                label={label}
            />
        </FormGroup>
    );
}